import { Plugin } from '@nuxt/types';

import { GetMeResponse, LSPermissionNameEnum, Organization } from 'wklr-backend-sdk/models';
import { useAuth } from './auth';
import { getDurationState } from 'wklr-shared/dist/utils/duration';

// TODO: irisと統合する

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ONB?: any;
  }
}

function getOrganizationStatus(organization: Organization): string | undefined {
  const now = new Date();
  if (getDurationState(now, organization.paidFrom, organization.paidUntil) === 'within') {
    return '本利用';
  }
  if (getDurationState(now, organization.trialFrom, organization.trialUntil) === 'within') {
    return 'トライアル';
  }
  return undefined;
}

export function collectUserParams(auth: GetMeResponse): Record<string, string | undefined> {
  const userParams: Record<string, string | undefined> = {
    user_id: auth.id,
    user_group_id: auth.organization.oid,
    organization_type: auth.organization.organizationType?.name,
    wandh_plan_type: auth.labsWandhPlan?.name,
    organization_status: getOrganizationStatus(auth.organization) || '',
  };

  const permissions = new Set(...auth.organization.permissions);
  for (const permission of Object.values(LSPermissionNameEnum)) {
    userParams[`permission_${permission}`] = String(permissions.has(permission));
  }

  return userParams;
}

function initializeOnBoarding(user: GetMeResponse) {
  const userAgent = window.navigator.userAgent.toLowerCase();
  if (
    userAgent.indexOf('msie') === -1 &&
    userAgent.indexOf('trident') === -1 &&
    !document.querySelector('#stands_onbd_point')
  ) {
    const ONB = (window.ONB ||= {});
    ONB.ignition_url = 'https://api.onboarding-app.io/v1/onboarding-init?aid=157&pid=327';

    ONB._queryparam = collectUserParams(user);
    ONB.black_list = [];
    ONB._custom_functions = {};

    ONB.embed = function () {
      for (ONB.item in ONB._queryparam) {
        ONB.ignition_url += '&' + ONB.item + '=' + encodeURIComponent(ONB._queryparam[ONB.item]);
      }
      for (ONB.d = 0; ONB.d < ONB.black_list.length; ONB.d++) {
        if (location.href.indexOf(ONB.black_list[ONB.d]) != -1) {
          return;
        }
      }
      if (Object.keys(ONB._custom_functions).length > 0) {
        ONB.ignition_url += '&custom_functions=' + encodeURIComponent(JSON.stringify(ONB._custom_functions));
      }
      ((ONB.b = document.createElement('script')), (ONB.c = document.getElementsByTagName('head')[0]));
      ONB.b.src = ONB.ignition_url;
      ONB.b.id = 'stands_onbd_point';
      ONB.b.charset = 'utf-8';
      ONB.b.async = 'async';
      ONB.c.appendChild(ONB.b);
    };
    ONB.embed();
  }
}

export default <Plugin>(async () => {
  const auth = useAuth();

  initializeOnBoarding(auth.user);
});
